"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _order = require("@/api/order");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddAddressGHN = _interopRequireDefault(require("./AddAddressGHN.vue"));
var _AddAddressGHTK = _interopRequireDefault(require("./AddAddressGHTK.vue"));
var _FilterOrder = require("./FilterOrder.vue");
var AddPickupAddressModal = /*#__PURE__*/function (_Vue) {
  function AddPickupAddressModal() {
    var _this;
    (0, _classCallCheck2.default)(this, AddPickupAddressModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AddPickupAddressModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "tabName", "ghtk");
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "pickup", []);
    (0, _defineProperty2.default)(_this, "lotnumbers", []);
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "usingCustomerAddress", false);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "type", "");
    (0, _defineProperty2.default)(_this, "totalMoney", 0);
    (0, _defineProperty2.default)(_this, "rules", {});
    return _this;
  }
  (0, _inherits2.default)(AddPickupAddressModal, _Vue);
  return (0, _createClass2.default)(AddPickupAddressModal, [{
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      if (data.orderProgress.deliveryFeeType == "NO_PUBLISH") {
        this.tabName = "ghn";
      } else {
        this.tabName = "ghtk";
      }
      // this.type = type;
      this.visible = true;
      this.status = "update";
    }
  }, {
    key: "handleSaveGHN",
    value: function () {
      var _handleSaveGHN = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$refs.ghn.$refs.form.validate();
            case 3:
              this.loading = true;
              data = this.$refs.ghn.$refs.form.model;
              _context.next = 7;
              return _order.orderApi.createGHN(this.form.id, data);
            case 7:
              this.$notify.success({
                title: "Send order",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 10:
              _context.prev = 10;
              this.loading = false;
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 10, 13]]);
      }));
      function handleSaveGHN() {
        return _handleSaveGHN.apply(this, arguments);
      }
      return handleSaveGHN;
    }()
  }, {
    key: "handleSaveGHTK",
    value: function () {
      var _handleSaveGHTK = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$refs.ghtk.$refs.form.validate();
            case 3:
              this.loading = true;
              data = this.$refs.ghtk.$refs.form.model;
              _context2.next = 7;
              return _order.orderApi.createGHTK(this.form.id, data);
            case 7:
              this.$notify.success({
                title: "Send order",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 10:
              _context2.prev = 10;
              this.loading = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 10, 13]]);
      }));
      function handleSaveGHTK() {
        return _handleSaveGHTK.apply(this, arguments);
      }
      return handleSaveGHTK;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], AddPickupAddressModal.prototype, "orderStatus", void 0);
AddPickupAddressModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddAddressGHTK: _AddAddressGHTK.default,
    AddAddressGHN: _AddAddressGHN.default
  }
})], AddPickupAddressModal);
var _default = exports.default = AddPickupAddressModal;